<template>
    <Tooltip>
        <template #tooltip-trigger>
            <span
                class="status-dot"
                :class="dotClass"
                :style="dotStyle"
                :title="tooltip"
            ></span>
        </template>
        <template #tooltip-content v-if="tooltip">
            {{ tooltip }}
        </template>
    </Tooltip>
</template>

<script>
import Tooltip from '@/components/fields/ToolTip.vue';
export default {
    name: 'StatusDot',
    components: {
        Tooltip,
    },
    props: {
        status: {
            type: String,
            required: true,
            validator: (value) => {
                return [
                    'success',
                    'warning',
                    'danger',
                    'neutral',
                    'muted',
                    'resolved',
                    'in_progress',
                    'findings',
                ].includes(value.toLowerCase());
            },
        },
        size: {
            type: [String, Number],
            default: 14,
        },
        tooltip: {
            type: String,
            default: '',
        },
    },
    computed: {
        dotClass() {
            const statusLower = this.status.toLowerCase();

            // Map status values to CSS classes
            if (statusLower === 'resolved' || statusLower === 'success') {
                return 'success';
            } else if (
                statusLower === 'in_progress' ||
                statusLower === 'warning'
            ) {
                return 'warning';
            } else if (statusLower === 'findings' || statusLower === 'danger') {
                return 'danger';
            } else if (statusLower === 'neutral' || statusLower === 'muted') {
                return 'neutral';
            }

            return 'neutral';
        },
        dotStyle() {
            const size =
                typeof this.size === 'number' ? `${this.size}px` : this.size;
            return {
                width: size,
                height: size,
            };
        },
    },
};
</script>

<style scoped>
.status-dot {
    display: inline-block;
    border-radius: 50%;
    flex-shrink: 0;
    vertical-align: middle;
}

.status-dot.success {
    background: var(--success); /* #019e7c */
}

.status-dot.warning {
    background: var(--warning); /* #ffcc00 */
}

.status-dot.danger {
    background: var(--danger); /* #cc3300 */
}

.status-dot.neutral {
    background: var(--neutral-700);
}
</style>
